/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ar_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reduce & resize ratios`)
};

const es_ar_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reduce y redimensiona relaciones`)
};

const de_ar_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verhältnisse kürzen & Größe ändern`)
};

const nl_ar_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vereenvoudig en pas verhoudingen aan`)
};

const fr_ar_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réduire et redimensionner les rapports`)
};

const it_ar_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riduci e ridimensiona i rapporti`)
};

const pt_br2_ar_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reduza e redimensione taxas`)
};

const pt_ar_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reduzir e redimensionar proporções`)
};

const ja_ar_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比率の縮小とリサイズ`)
};

const zh_ar_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`化简并调整比例大小`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ar_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ar_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ar_nav_main_desc", locale)
	if (locale === "en") return en_ar_nav_main_desc(inputs)
	if (locale === "es") return es_ar_nav_main_desc(inputs)
	if (locale === "de") return de_ar_nav_main_desc(inputs)
	if (locale === "nl") return nl_ar_nav_main_desc(inputs)
	if (locale === "fr") return fr_ar_nav_main_desc(inputs)
	if (locale === "it") return it_ar_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_ar_nav_main_desc(inputs)
	if (locale === "pt") return pt_ar_nav_main_desc(inputs)
	if (locale === "ja") return ja_ar_nav_main_desc(inputs)
	return zh_ar_nav_main_desc(inputs)
};